import styled, { css } from 'styled-components';
import { Wrapper as ColorSwatchWrapper, OuterDot } from '../ColorSwatch/styles';
import { TypeStyle } from '../TypeStyle';
const hideVisually = css `
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;
export const Label = styled.label `
  cursor: ${o => (o.$disabled ? 'not-allowed' : 'pointer')};
  display: flex;
  padding: 6px 0;

  > ${ColorSwatchWrapper} {
    margin-inline-end: 8px;
    pointer-events: none;
    > ${OuterDot} {
      border-style: ${o => o.$disabled && 'none'};
    }
  }

  &:hover {
    outline: none;

    > ${ColorSwatchWrapper} > ${OuterDot} {
      border-color: ${o => o.$checked ? o.theme.color.deprecated.obsidian : o.theme.color.deprecated.stoneDark};
    }
  }

  > input {
    ${hideVisually}
  }

  /* 'data-focus-visible' is added by AriaKit.Focusable */
  &:has(input[data-focus-visible]) {
    outline: 1px auto Highlight;
    outline: 1px auto -webkit-focus-ring-color;
  }
`;
export const StyledText = styled(TypeStyle.BodySmall) `
  color: ${o => o.disabled && o.theme.color.deprecated.stoneDark};
  font-weight: ${o => o.checked ? o.theme.typography.font.weight['600'] : o.theme.typography.font.weight['400']};
`;
//# sourceMappingURL=styles.js.map